import { darken } from 'polished';
import styled from 'styled-components';

export const Container = styled.div`
  margin-top: -0.2rem;

  svg {
    width: 1rem;
    height: 1rem;

    .fa-primary {
      color: ${({ theme }) => theme.colors.texts};
    }

    .fa-secondary {
      color: ${({ theme }) => darken(0.1, theme.colors.medium.color)};
    }
  }
`;
